import type { EscapedString } from '../c-mp/fun/html'
import type { ITreePerson } from '../model/ITreePerson'
import { drawConnector } from './drawConnector'
import { drawMarriageLabel } from './drawMarriageLabel'
import { drawPerson } from './drawPerson'
import { getTreePersonRelationship } from './getTreePersonRelationship'
import { type ISubtreeSize, PERSON_HEIGHT, PERSON_WIDTH } from './makeSvgTree'

export function drawTreePerson({
	test,
	content,
	tp,
	x,
	y,
	isFocused,
}: {
	test: SVGElement
	content: (EscapedString | string)[]
	tp: ITreePerson
	x: number
	y: number
	isFocused?: boolean
}): ISubtreeSize {
	const size: ISubtreeSize = {
		width: 0,
		height: 0,
		x: x,
	}
	const nextXs: number[] = []
	for (const next of tp.next) {
		const nextSize = drawTreePerson({
			test,
			content,
			tp: next,
			x: x + size.width,
			y: y + PERSON_HEIGHT,
		})
		nextXs.push(nextSize.x)
		size.width += nextSize.width
		size.height = Math.max(size.height, nextSize.height)
	}
	if (nextXs.length === 1) {
		size.x = nextXs[0]!
	} else if (nextXs.length > 1) {
		size.x = (nextXs.at(0)! + nextXs.at(-1)!) / 2
	}
	drawPerson({
		test,
		content,
		person: tp.person,
		imageUrl: tp.imageUrl,
		x: size.x,
		y,
		isFocused,
		relationship: getTreePersonRelationship(tp),
	})
	size.width = Math.max(size.width, PERSON_WIDTH)
	size.height += PERSON_HEIGHT

	let nextIndex = -1
	for (const nextX of nextXs) {
		nextIndex++
		drawConnector({
			content,
			x1: size.x,
			y1: y,
			x2: nextX,
			y2: y + PERSON_HEIGHT,
			isDashed: !tp.coupleWithPrevious,
		})
		if (!tp.coupleWithPrevious) {
			const next = tp.next[nextIndex]!
			if (next.coupleWithPrevious) {
				const mx = (size.x + nextX + PERSON_WIDTH) / 2
				const my = y + PERSON_HEIGHT
				drawMarriageLabel(test, content, next.coupleWithPrevious, mx, my)
			}
		}
	}
	return size
}
